import { render, staticRenderFns } from "./SectorInfo.vue?vue&type=template&id=0b68074e&lang=pug&"
import script from "./SectorInfo.vue?vue&type=script&lang=js&"
export * from "./SectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports